<div class="schedule-amount-modal-container display-flex flex-column">
  <h2 mat-dialog-title class="modal-header">
    <div class="subtitle mr-4">{{ data.cellData.amount ? 'Update Amount' : 'Enter Amount' }}</div>
  </h2>
  <mat-dialog-content class="display-flex align-items-center grid-gap-4">
    <span class="text-color gray11 mb-1">$</span>
    <mat-form-field floatLabel="never">
      <input
        [ngClass]="[amount | numberValidation: 0]"
        (keydown.enter)="send(input.value)"
        (keyup)="keyUp($event, input)"
        #input
        type="text"
        matInput
        [(ngModel)]="amount"
        mask="separator.2"
        thousandSeparator=","
        [allowNegativeNumbers]="true"
      />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-space-between align-items-center">
    <button class="modal-button" mat-stroked-button [color]="'warn'" (click)="cancel()">Cancel</button>
    <button class="modal-button" mat-raised-button [color]="'primary'" (click)="send(input.value)">Save</button>
  </mat-dialog-actions>
</div>
